import { SeuApiConverter, SeuCanvas, SeuCanvasApi } from '@seu-types';

export const canvasConverter: SeuApiConverter<SeuCanvas, SeuCanvasApi> = {
  fromApi: (input) => {
    const canvas: SeuCanvas = {
      ...input,
      canvasStreams: input.canvasStreams.map((canvasStream) => {
        return {
          ...canvasStream,
          outputFromComponentId: canvasStream.outputFromComponentId
            ? String(canvasStream.outputFromComponentId)
            : null,
          inputForComponentId: canvasStream.inputForComponentId
            ? String(canvasStream.inputForComponentId)
            : null,
          outputFromComponentHandleId:
            canvasStream.outputFromComponentHandleId ?? null,
          inputForComponentHandleId:
            canvasStream.inputForComponentHandleId ?? null,
        };
      }),
      components: input.components.map((component) => {
        // **** In the future these checks can be removed ****
        // move components from old offers lying on x0,y0 to x0,y1, to prevent interference with first input stream and global parameter
        if (
          component.posX === 0 &&
          // added feb 24, 2026 to also target initially moved components which then interfered with global params
          (component.posY === 0 || component.posY === 1)
        ) {
          return {
            ...component,
            componentId: String(component.componentId),
            posY: 1,
            posX: 1,
          };
        }
        return {
          ...component,
          componentId: String(component.componentId),
        };
      }),
    };

    return canvas;
  },
  toApi: (input) => {
    const canvas: SeuCanvasApi = {
      ...input,
      canvasStreams: input.canvasStreams.map((canvasStream) => {
        return {
          ...canvasStream,
          outputFromComponentId: canvasStream.outputFromComponentId
            ? Number(canvasStream.outputFromComponentId)
            : null,
          inputForComponentId: canvasStream.inputForComponentId
            ? Number(canvasStream.inputForComponentId)
            : null,
        };
      }),
      components: input.components.map((component) => {
        return {
          componentId: Number(component.componentId),
          posX: component.posX,
          posY: component.posY,
        };
      }),
    };
    return canvas;
  },
};
